<template>
  <div class="not-found-page">
    <div class="container pt-5 pb-5">
      <h1>Page not Found</h1>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: "NoFound",
  components: {
    Footer
  }
}
</script>